// extracted by mini-css-extract-plugin
export default {"logoutContainer":"style_logoutContainer__52POR"};